import { render, staticRenderFns } from "./StateInventory.vue?vue&type=template&id=0865f992&scoped=true&"
import script from "./StateInventory.vue?vue&type=script&lang=js&"
export * from "./StateInventory.vue?vue&type=script&lang=js&"
import style0 from "./StateInventory.vue?vue&type=style&index=0&id=0865f992&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0865f992",
  null
  
)

export default component.exports